// src/observations/store/reducers/observations.reducer.js
import * as Actions from '../actions/observations.actions';

const initialState = [];

export default function observations(state = initialState, action = {}) {
  switch (action.type) {
    case Actions.GET_OBSERVATIONS:
      return action.payload;

    case Actions.ADD_OBSERVATION:
      return [...state, action.payload];

    case Actions.UPDATE_OBSERVATION:
    case Actions.GET_OBSERVATION: {
      const idx = state.findIndex((o) => o.id === action.payload.id);
      const newState = [...state];
      newState[idx > -1 ? idx : state.length] = action.payload;
      return newState;
    }

    case Actions.REMOVE_OBSERVATION:
      return state.filter((o) => o.id !== action.payload.id);

    default:
      return state;
  }
}
